<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      Edit Template {{ selectedTemplate ? `- ${selectedTemplate.name}` : '' }}
    </template>
    <template #body>
      <SubSection sub-section-heading="Advanced" :sub-section-nav="subSectionNav">
        <template #body>
          <template v-if="!isSavableStateLoading && selectedTemplate">
            <div class="bordered-section">
              <TemplateEnableToggle
                :template-disabled-at="selectedTemplate.disabledAt"
                :template-id="templateId"
                @load-template="loadTemplate" />
            </div>
          </template>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>

<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import SubSection from "@/src/components/shared/SubSection.vue";
import { useTemplateStore } from '@/src/stores/template';
import { pageMixin } from "@/src/mixins/pageMixin";
import { templateSubSectionNavMixin } from "@/src/components/admin-area/templates/templateSubSectionNavMixin";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import TemplateEnableToggle from "@/src/components/admin-area/templates/TemplateEnableToggle.vue";

export default {
  components: {
    CardSection,
    SubSection,
    TemplateEnableToggle
  },
  mixins: [ pageMixin, savableStateMixin, templateSubSectionNavMixin ],
  setup() {
    const templateStore = useTemplateStore();
    return {
      templateStore
    }
  },
  data() {
    return {
      selectedTemplate: null,
      templateId: this.$route.params.id
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      this.loadTemplate(await this.templateStore.loadTemplate(this.$route.params.id));
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    loadTemplate(template) {
      this.selectedTemplate = {
        id: template.id,
        name: template.communication_template_category.category_name + ' - ' + template.organ_group.name + ' - ' + template.transplant_center.code,
        templateBody: template.template_body,
        disabledAt: template.disabled_at
      }
    }
  }
}
</script>
